export default {"src":"/_next/static/media/product-categories-icon.2974517a.svg","height":14,"width":17,"blurWidth":0,"blurHeight":0};